/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Rush Hour Real Estate Platform API
 * MVP платформы недвижимости - публичные эндпоинты
 * OpenAPI spec version: 1.0.0
 */

export type LotType = (typeof LotType)[keyof typeof LotType]

export const LotType = {
  apartment: 'apartment',
  villa: 'villa',
  townhouse: 'townhouse',
  penthouse: 'penthouse',
  duplex: 'duplex',
  triplex: 'triplex',
} as const
